import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'cookies-bottom-sheet',
  templateUrl: './cookies-bottom-sheet.component.html',
  styleUrls: ['./cookies-bottom-sheet.component.css']
})
export class CookiesBottomSheetComponent implements OnInit {

  constructor(
    // @Inject(MAT_BOTTOM_SHEET_DATA) 
    // private data: {title: string, message: string},
    private matBottomSheetRef: MatBottomSheetRef
  ) { }

  ngOnInit(): void {
  }

  // ngOnDestroy(){
  //   this.matBottomSheetRef.dismiss(this.data)
  // }

  onAcceptedClicked(){
    this.matBottomSheetRef.dismiss(true);
  }

}
